import { ErrorMessages } from "../actions/constants/common"
import env from "./env"
import tlds from 'tlds'

export const getAccessToken = () => {
    const auth = localStorage.getItem("AUTHDATA")
    if (auth) {
        return JSON.parse(auth).token
    }
}

export const getUserRole = () => {
    const auth = localStorage.getItem("AUTHDATA")
    if (auth) {
        return JSON.parse(auth).role
    }
}
export const getAuthUser = () => {
    const auth = localStorage.getItem("AUTHDATA")
    if (auth) {
        return JSON.parse(auth)
    }
}

export const isAtLeast18YearsOld = (dateString: any) => {
    if (!dateString) return false;
    const today = new Date();
    const birthDate = new Date(dateString);
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    return (age > 18 || (age === 18 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0))));
};

export const Capitalize = (char: any) => {
    if (typeof char !== 'string') return ''
    return char.toLowerCase().split(' ').map(s => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
}

export const isInt32 = (value: any) => {
    return Number.isInteger(value) &&
        value >= -2147483648 &&
        value <= 2147483647;
}

export const toInt32 = (value: any) => {
    if (value > 2147483647) {
        value = value % 2147483648;
    }
    if (value < -2147483648) {
        value = value + 4294967296;
    }
    return value | 0;
}

export const getTime = (value: any) => {
    const date = new Date(value);
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const time = `${hours}:${minutes < 10 ? '0' : ''}${minutes} ${period}`;
    return time;
}

export const getTimeOut = (value: any) => {
    const timeout = sessionStorage.getItem("timeout")
    const newTime = (value - Math.floor(Date.now() / 1000)) * 1000
    const time = timeout ? timeout : isInt32(newTime) ? newTime : toInt32(newTime)
    return Number(time);
}

export const getRenewalTimeBeforeExpiry = (value: any) => {
    const renewal = sessionStorage.getItem("isTestRenewal")
    const time = renewal ? renewal : (Number(value) - (Number(env.renewalTimeBeforeExpiry) * 60))
    return Number(time);
}

export const getPromptBeforeIdle = () => {
    const prompt = sessionStorage.getItem("isTestPrompt")
    const newTime = env.promptBeforeIdle * 60 * 1000
    const time = prompt ? prompt : isInt32(newTime) ? newTime : toInt32(newTime)
    return Number(time);
}

export const getCurrentTime = () => {
    const sese = sessionStorage.getItem("currentTime")
    const time = sese ? sese : Math.floor(Date.now() / 1000)
    return Number(time);
}

export const getIsValidSession = (auth: any) => {
    const user = localStorage.getItem("AUTHDATA")
    const currentTime = getCurrentTime()
    if (user) {
        const authUser = JSON.parse(user)
        if (authUser) {
            if (currentTime < authUser?.tokenExpery) {
                return authUser
            } else if (currentTime >= authUser?.tokenExpery) {
                return null
            }
        }
    }
}

export const getIsTest = () => {
    const isTest = sessionStorage.getItem("isTest")
    if (isTest) return true
    else return false
}


export const emailValidate = (email: string) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const tld: any = email.split('.').pop();
    if (!emailRegex.test(email) || !tlds.includes(tld)) {
        return false
    }
    return true;
};

export const isIOS = (): boolean => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window?.MSStream;
};

export const blobUrl = env.prod ? env.blob_prod : env.blob_dev;

export const hexToHSL = (hex: any) => {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
        hex = hex.split('').map((x: any) => x + x).join('');
    }

    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h = 0, s, l;
    l = (max + min) / 2;

    if (max === min) {
        h = s = 0;
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max) {
            case r: h = ((g - b) / d + (g < b ? 6 : 0)); break;
            case g: h = ((b - r) / d + 2); break;
            case b: h = ((r - g) / d + 4); break;
        }
        h = Math.round(h * 60);
    }
    const hsl = h + "," + s * 100 + "," + l * 100
    console.log(`hsl(${Math.round(h)}, ${s * 100}%, ${l * 100}%)`);
    return hsl;
}

export const hslToHex = (value: any) => {
    let h = 0, s = 100, l = 50;

    if (typeof value === 'string' && value.includes(',')) {
        [h, s, l] = value.split(',').map(Number);
    } else if (typeof value === 'number' || !value.includes(',')) {
        h = Number(value);
    }

    const sDecimal = s / 100;
    const lDecimal = l / 100;

    const c = (1 - Math.abs(2 * lDecimal - 1)) * sDecimal;
    const x = c * (1 - Math.abs((h / 60) % 2 - 1));
    const m = lDecimal - c / 2;

    let r = 0, g = 0, b = 0;

    if (h >= 0 && h < 60) [r, g, b] = [c, x, 0];
    else if (h < 120) [r, g, b] = [x, c, 0];
    else if (h < 180) [r, g, b] = [0, c, x];
    else if (h < 240) [r, g, b] = [0, x, c];
    else if (h < 300) [r, g, b] = [x, 0, c];
    else if (h <= 360) [r, g, b] = [c, 0, x];

    const toHex = (n: number) => {
        const hex = Math.round((n + m) * 255).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    };

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};